export default "__VITE_ASSET__hms4JEFC__"